// extracted by css-extract-rspack-plugin
export default {"root":"root-hMSNLZ","loading":"loading-nKZT4s"};